import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../app/hooks';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import { SelectedPlan } from '../../components/common/VirtualOfficeSubscription/SelectedPlan';
import { VirtualOfficeGrid } from '../../components/common/VirtualOfficeSubscription/VirtualOfficeGrid';
import { dateDifferenceInDaysFromToday } from '../../helpers/helperFunctions';
import { getUserTickets } from '../../slices/auth-slice';
import { H2, H4, P1, P2 } from '../../styles/FontStyles';
import { Box, Flexed } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import { getLicenses } from './Settings.actions';

export const VirtualOffice = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState();
  const [step, setStep] = useState(1);
  const { user, licences } = useAppSelector((state) => state.settings);
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();

  const date = user?.currentVirtualOfficeLicence?.dateEnd;

  const virtualOfficeEndDate = moment(date).format('Do of MMMM YYYY');

  const dateEnded = dateDifferenceInDaysFromToday(date) === 0;

  const isTrialLicense = user?.currentVirtualOfficeLicence.licenceId === null;

  useEffect(() => {
    dispatch(getLicenses());
  }, [dispatch]);

  return (
    <Flexed gap='50px' gapSM='0px' rowSM>
      <Flexed column width='30%' widthSM='100%'>
        <H4 bold color={colors.primary900} mb='15'>
          BackOffice Subscription
        </H4>
        <P2 mb='45' mt='5' color={colors.neutral700}>
          United One Back Office is your access to many exclusive opportunities
          to earn money, connect and learn among the community of business
          oriented individuals.
        </P2>

        <Box gray p='20px'>
          <Flexed justifyCenter>
            <P2 mb='20' color={colors.primary900}>
              {t('virtual_office.text2')}
            </P2>
          </Flexed>

          {dateEnded ? (
            <Flexed justifyCenter>
              <P2 bold center color={colors.primary900}>
                {t('virtual_office.not_active')}{' '}
                <span style={{ color: colors.error500 }}>
                  {t('virtual_office.expired')}
                </span>
              </P2>
            </Flexed>
          ) : (
            <Flexed justifyCenter>
              <P1 bold center color={colors.primary900}>
                {isTrialLicense && t('virtual_office.in_trial')}{' '}
                {t('virtual_office.banner.valid_until')} <br />{' '}
                {virtualOfficeEndDate}
              </P1>
            </Flexed>
          )}

          <Flexed
            gray
            style={{
              width: 150,
              height: 150,
              borderRadius: 100,
              backgroundColor: colors.primary900,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              margin: '0 auto',
              marginTop: 20,
              marginBottom: 10
            }}>
            <H2 center color={colors.neutral0}>
              {`${dateDifferenceInDaysFromToday(
                user?.currentVirtualOfficeLicence?.dateEnd
              )}`}
              <br />
            </H2>
            <P1 semiBold color={colors.neutral0}>
              Days Left
            </P1>
          </Flexed>
        </Box>
      </Flexed>
      <Flexed column width='70%' widthSM='100%'>
        <P1 color={colors.primary900} mb='15' mt='40' mtSM='0'>
          Avoid losing your benefits
        </P1>
        <P2 mb='40' mbSM='20' color={colors.neutral700}>
          Expired Back Office subscription means that your business volume is
          not accumulating and you are not receiving any bonuses in the period
          when you don’t have an active Back Office subscription.
          <br />
          <br />
          Avoid the risk and extend the subscription now. The new subscription
          you purchase will activate when the current one expires.
        </P2>

        <VirtualOfficeGrid
          setSelected={setSelected}
          setIsOpen={setIsOpen}
          setStep={setStep}
          licences={licences}
        />
      </Flexed>

      <SidebarModal
        isOpen={isOpen}
        setOpen={setIsOpen}
        title={t('virtual_office.backoffice_subscription')}
        sidebarWidth={'600px'}>
        <SelectedPlan
          selected={selected}
          setSelected={setSelected}
          step={step}
          setStep={setStep}
        />
      </SidebarModal>
    </Flexed>
  );
};
